<template>
   <div class="layout-page">
      <h1>Email Templates</h1>

      <p>Use this page to create and edit your own templates for the emails you create and send.</p>

      <div class="container-fluid">
         <div class="row">
            <div class="col" v-if="!showEditor && !busy">
               <p class="instructions">Choose a Template to Edit</p>
               <div class="row">
                  <div class="col-sm-7">
                     Template Type:
                     <span class="form-control-static">Recruitment Invitation Email</span>
                  </div>
                  <div class="col-sm-2 text-right">
                     <button type="button" class="btn btn-sm ml-btn ml-white ml-bk-corp ml-h-black" @click.prevent="addTemplate">
                        <i class="fas fa-plus"></i>
                        ADD TEMPLATE
                     </button>
                  </div>
               </div>
               <div class="row font-smaller mart-12" v-if="hasData()">
                  <div class="col-sm-9">
                     <data-grid :headers="headers" :records="userTemplates" :rowsPerPage="rowsPerPage"
                        :currentPage="currentPage" :totalRecords="totalRecords" :clickHandler="gridClickHandler"
                        :navHandler="gridNavHandler" :noDataMsg="noDataMsg"
                        @page-size-changed="pageChanged" :hideFooter="true"></data-grid>
                  </div>
               </div>
               <div class="text-danger mart-12" v-if="!hasData()">
                  {{ noDataMsg }}
               </div>
            </div>
            <div class="col" v-if="showEditor && !busy">
               <div class="row padb-12">
                  <div class="col-sm-2">
                     Type:
                  </div>
                  <div class="col-sm-4 form-control-static">
                     Recruitment Invitation Email
                  </div>
                  <div class="col-sm-4">
                     <div class="custom-control form-control-lg custom-checkbox font-smaller">
                        <input type="checkbox" id="chkIsActive" class="custom-control-input" v-model="curTemplate.isActive" />
                        <label class="custom-control-label" for="chkIsActive">Is Active</label>
                     </div>
                  </div>
               </div>
               <div class="row padb-12">
                  <div class="col-sm-2">
                     Name:
                  </div>
                  <div class="col-sm-8">
                     <input type="text" class="form-control" v-model="curTemplate.name" maxlength="50" />
                  </div>
               </div>
               <div class="row padb-12">
                  <div class="col-sm-2">
                     Description:
                  </div>
                  <div class="col-sm-8">
                     <textarea class="form-control" v-model="curTemplate.description" rows="2" cols="40" maxlength="560"></textarea>
                  </div>
               </div>

               <div class="row padb-12">
                  <div class="col-sm-10">
                     <p>Template:</p>

                     <p class="instructions">
                        Create an email in the following window and drop fields where you want the data to go. 
                        To add a field, put the cursor in email where you want the data, choose the data field 
                        from the toolbar, and click the toolbar PLUS icon. Click the question mark (?) on the 
                        toolbar for more information.
                     </p>

                     <cust-editor 
                        v-model="curTemplate.html" 
                        :fields="fieldDefinitions" 
                        :images="templateImages"
                        :templateId="templateId"
                        @img-uploaded="imageUploaded" />

                     <div class="text-right">
                        <button type="button" class="btn ml-btn ml-bk-orange ml-white ml-h-black marr-24" @click.prevent="deleteTemplate">
                           <i class="fas fa-spinner fa-spin" v-if="busy"></i>
                           <span v-else>
                              <i class="fas fa-times"></i>
                              DELETE TEMPLATE
                           </span>
                        </button>
                        <button type="button" class="btn ml-btn ml-bk-black ml-white ml-h-orange marr-12 btnw" @click.prevent="cancel">
                           <i class="fas fa-spinner fa-spin" v-if="busy"></i>
                           <span v-else>
                              <i class="fas fa-times"></i>
                              CANCEL
                           </span>
                        </button>
                        <button type="button" class="btn ml-btn ml-bk-corp ml-white ml-h-black btnw" @click.prevent="save">
                           <i class="fas fa-spinner fa-spin" v-if="busy"></i>
                           <span v-else>
                              <i class="fas fa-check"></i>
                              SAVE
                           </span>
                        </button>
                     </div>
                  </div>
               </div>
               <div v-if="false">{{ curTemplate.html }}</div>
            </div>
            <div class="col padl-24 ml-orange" v-if="busy">
               <i class="fas fa-spinner fa-spin fa-lg"></i> Please Wait...
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import DataGrid from "@/components/datagrid.vue"
import CustEditor from "@/components/CustEditor"

const headerFields = [
   {
      name: "name",
      label: "Name",
      sortkey: '',
      filterkey: '',
      isdate: false,
      isdatetime: false,
      ismoney: false,
   },
   {
      name: "description",
      label: "Description",
      sortkey: '',
      filterkey: '',
      isdate: false,
      isdatetime: false,
      ismoney: false,
   },
   {
      name: "isActive",
      label: "Is Active",
      sortkey: '',
      filterkey: '',
      isdate: false,
      isdatetime: false,
      ismoney: false
   },
   {
      name: "updateDt",
      label: "Modified",
      sortkey: '',
      filterkey: '',
      isdate: true,
      isdatetime: false,
      ismoney: false
   },
   {
      name: "__ACTION",
      label: "Edit",
      sortkey: '',
      filterkey: '',
      isdate: false,
      isdatetime: false,
      ismoney: false,
      mustShowDetail: false,
   }

]


export default {
   name: 'Protected',
   components: {
      'cust-editor': CustEditor,
      'data-grid': DataGrid 
   },
   data() {
      return {
         userId: this.$store.getters.appUser.userId,
         fields: [],
         fieldDefinitions: [],
         templateImages: [],
         query: null,
         suggestionRange: null,
         filteredFields: [],
         navigatedUserIndex: 0,
         insertMention: () => { },
         showEditor: false,
         selectedTemplate: {},
         userTemplates: [],
         templateId: 0,

         //grid related
         headers: headerFields,
         rowsPerPage: 100,
         currentPage: 1,
         totalRecords: 0,
         noDataMsg: '* No templates were found. Please click the Add button to create one.',
         filters: [],
         sorts: [],
         templateTypes: [],
         curTemplateTypeId: 1003,
         templateTypeCode: 'CORTYP_MLT_INVITE',
         curTemplate: {},
         blankTemplate: {},
         busy: false
      }
   },
   computed: {
      hasResults() {
         return this.filteredFields.length
      }
   },
   async mounted() {
      await this.initialize()
   },
   methods: {
      async initialize() {
         this.busy = true
         await this.fetchBlankTemplate()
         await this.fetchUserTemplates()
         this.busy = false
      },
      async fetchBlankTemplate() {
         await this.$template.getBlankTemplate()
            .then(async (r) => {
               if (r) {
                  this.blankTemplate = r
                  this.blankTemplate.name = ''
                  this.blankTemplate.description = ''
                  this.blankTemplate.userId = this.userId
               } 
            })
            .catch(err => {
               this.$swal(
                  "System Error",
                  "Oops! Some unforseen system error occurred while trying to retrieve blank template types. Please try again later. If this problem persists please contact support.",
                  "error"
               );
            })
      },
      async fetchUserTemplates() {
         await this.$template.getTemplateTypes()
            .then(async (r) => {
               if (r) {
                  this.templateTypes = r
                  // this is the only one we support for now...
                  this.curTemplateTypeId = this.templateTypes.find(t => t.templateTypeCode == this.templateTypeCode).id
                  await this.fetchFields()
                  await this.refreshData()
               } 
            })
            .catch(err => {
               this.$swal(
                  "System Error",
                  "Oops! Some unforseen system error occurred while trying to retrieve template types. Please try again later. If this problem persists please contact support.",
                  "error"
               );
            })
      },
      async fetchFields() {
         await this.$template.getTemplateFields(this.curTemplateTypeId)
            .then(async (r) => {
               if (r) {
                  this.fieldDefinitions = r
                  this.fields = []
                  this.fieldDefinitions.forEach((itm) => {
                     this.fields.push({ id: itm.id, label: itm.label })
                  })
               }
            })
            .catch(err => {
               this.$swal(
                  "System Error",
                  "Oops! Some unforseen system error occurred while trying to retrieve fields. Please try again later. If this problem persists please contact support.",
                  "error"
               );
            })
      },
      hasData() {
         if (this.userTemplates != []) {
            return this.userTemplates.length > 0
         }
         return false
      },
      async cancel() {
         this.busy = true
         await this.refreshData()
         this.showEditor = false
         this.busy = false
      },
      async save() {
         if (this.curTemplate.name.trim()=='') {
            this.$swal(
               "Missing Template Name",
               "Please enter the required template Name before saving.",
               "error"
            )
            return
         }
         if (this.curTemplate.description.trim()=='') {
            this.$swal(
               "Missing Description",
               "Please enter the required Description before saving.",
               "error"
            )
            return
         }
         this.busy = true

         // Save it
         await this.$template.saveUserTemplate(this.curTemplate)
            .then(async (r) => {
               if (r && r == true) {
                  this.$swal(
                     "Done!",
                     "Your email template was successfully saved.",
                     "success"
                  )
                  .then(async () => {
                     await this.refreshData()
                     this.showEditor = false
                     this.busy = false
                  })
               } else {
                  this.$swal(
                     "System Error",
                     "Oops! Some unforseen system error occurred while trying to save the template. Please try again later. If this problem persists please contact support.",
                     "error"
                  )
                  this.busy = false
               }
            })
            .catch(err => {
               this.$swal(
                  "System Error",
                  "Oops! Some unforseen system error occurred while trying to save the template. Please try again later. If this problem persists please contact support.",
                  "error"
               )
               this.busy = false
            })
      },
      async deleteTemplate() {
         this.$swal({
            title: "Deleting is Not Reversible!",
            html:"Are you sure you want to delete this email template? The deletion cannot be reversed.",
            icon:"warning",
            heightAuto: false,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText:"Yes",
            confirmButtonColor: "#D14529",
            denyButtonText:"No",  
            denyButtonColor:'#2778C4',     
            reverseButtons: true,  
            focusConfirm: false,
         }).then(async result => {
            if (await result.isConfirmed) {
               this.busy = true

               await this.$template.deleteUserTemplate(this.curTemplate.corrTemplateId)
               .then(async (r) => {
                  if (r && r == true) {
                     await this.refreshData();
                     this.$swal(
                        "Deleted",
                        "Template deletion was successful.",
                        "success"
                     );
                     this.busy = false
                     this.showEditor = false
                  } else {
                     this.$swal(
                        "System Error",
                        "Oops! Some unforseen system error occurred while trying to delete a template. Please try again later. If this problem persists please contact support.",
                        "error"
                     );
                     this.busy = false
                  }
               })
               .catch(err => {
                  this.busy = false

                  this.$swal(
                     "System Error",
                     "Oops! Some unforseen system error occurred while trying to retrieve blank template types. Please try again later. If this problem persists please contact support.",
                     "error"
                  );
               })
            } 
         })
      },
      async gridClickHandler(item) {
         this.busy = true
         this.curTemplate = item
         this.templateId = this.curTemplate.corrTemplateId
         await this.fetchTemplateImages()
         this.showEditor = true
         this.busy = false
      },
      async gridNavHandler(command) {
         switch(command) {
               case 'FIRST':
                  this.searchPage = 0
                  break;
               case 'PREVIOUS':
                  this.searchPage--
                  break;
               case 'NEXT':
                  this.searchPage++
                  break;
               case 'LAST':
                  this.searchPage = this.searchTotalPages - 1
                  break;
         }
         await this.refreshData()
      },
      async pageChanged(newCount) {
         this.currentPage = 0;
         this.rowsPerPage = parseInt(newCount);
         await this.refreshData();
      },
      async refreshData() {
         await this.$template.listUserTemplatesByType(this.curTemplateTypeId, this.userId)
            .then(async (t) => {
               if (t) {
                  this.userTemplates = t
               }
            })
            .catch(err => {
               this.$swal(
                  "System Error",
                  "Oops! Some unforseen system error occurred while trying to retrieve templates. Please try again later. If this problem persists please contact support.",
                  "error"
               );
            })
      },
      async imageUploaded() {
         await this.fetchTemplateImages()
      },
      async fetchTemplateImages() {
         this.templateImages = []
         await this.$template.getTemplateImages(this.templateId)
            .then(async (r) => {
               if (r) {
                  this.templateImages = r
               }
            })
            .catch(err => {
               this.$swal(
                  "System Error",
                  "Oops! Some unforseen system error occurred while trying to retrieve images. Please try again later. If this problem persists please contact support.",
                  "error"
               );
            })
      },
      addTemplate() {
         this.busy = true
         this.curTemplate = JSON.parse(JSON.stringify(this.blankTemplate)) //copy
         this.showEditor = true
         this.busy = false
      }
   }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/colors.scss';
@import '../assets/css/email.scss';

.form-control-static {
   color: $corp-blue;
}

.instructions {
   color: $corp-purple;
}
.btnw {
   width: 100px;
}
</style>